import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { distinctUntilChanged, map, Subject, switchMap } from 'rxjs';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { DialogService, OnGetData } from '../../../services/dialog.service';
import { GalleryService } from '../../../services/gallery.service';
import { ShareService } from '../../../services/share.service';
import { ToastService } from '../../../services/toast.service';
import { ShareDirective } from '../../../shared-extra/directives/share.directive';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { EditableGalleryTeaserIconComponent } from '../../components/editable-gallery-teaser-icon/editable-gallery-teaser-icon.component';
import { ShareGalleryDialogComponent } from '../share-gallery-dialog/share-gallery-dialog.component';

@Component({
  selector: 'app-share-gallery-app-dialog',
  imports: [ButtonDirective, SvgComponent, ShareDirective, EditableGalleryTeaserIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './share-gallery-app-dialog.component.html',
  styleUrl: './share-gallery-app-dialog.component.scss',
})
export class ShareGalleryAppDialogComponent implements OnGetData {
  dialogName = 'share-gallery-app';
  dialog = inject(DialogService);
  toasts = inject(ToastService);
  private galleryService = inject(GalleryService);
  private shareService = inject(ShareService);

  private galleryId = new Subject<string>();
  gallery = toSignal(this.galleryId.pipe(switchMap(galleryId => this.galleryService.getGallery(galleryId))));

  installLink = toSignal(
    toObservable(this.gallery).pipe(
      distinctUntilChanged((a, b) => a?.path === b?.path),
      switchMap(gallery => this.shareService.getShareLink(gallery, { pwaLink: true })),
      map(link => link.url)
    )
  );

  dialogOptions(): DialogOptions {
    return {
      size: 560,
      spacingX: 24,
      spacingY: 24,
      hideClose: true,
    };
  }

  onGetData(data: { gallery: GalleryDto }) {
    this.galleryId.next(data.gallery.id);
  }

  onBack() {
    if (!this.gallery()) return;
    this.dialog.open(ShareGalleryDialogComponent, { gallery: this.gallery() });
  }

  onLinkCopied() {
    this.toasts.add('Link copied!', 'success');
  }
}
